let isTest = (window.location.origin === 'http://localhost:3000') ? true : false;
if(isTest) {
    module.exports = {
        Auth: {
            identityPoolId: 'us-east-2:9c3b4baf-15fb-44df-9672-8a4bc68ae30c',
            region: 'us-east-2',
            userPoolId: 'us-east-2_8Zzxi1RIv',
            userPoolWebClientId: '28fhpv17h7eq642jq4bdlcvvg2'
        }
    };
} else {
    module.exports = {
        Auth: {
            identityPoolId: 'ap-southeast-2:7a3ac96b-1e12-4a33-873b-f6c24eaadd6a',
            region: 'ap-southeast-2',
            userPoolId: 'ap-southeast-2_i93wbsIED',
            userPoolWebClientId: '2s7vmp7e5s85jtjp6ivp8ojcf2'
        }
    };
}
